import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface OpenProductGroupCardEntityParams {
  product_type_id: number;
  id: number;
}
export class OpenProductGroupCardEntity extends BaseEntityClass {
  product_type_id: number;
  limited_ordering_filter_id: number;

  constructor(params: OpenProductGroupCardEntityParams) {
    super();
    this.type = "open_product_group_card";
    this.entity_version = 1;
    this.product_type_id = params.product_type_id;
    this.limited_ordering_filter_id = params.id;
  }
}
